/* ABC: уведомление о коде скидки в нашем стиле.
   Правило владельца: сам код всегда КАПСОМ, остальной текст обычным
   предложением («С заглавной, дальше строчными»). Тема пишет безликое
   «Discount code cannot be applied to your cart» без самого кода —
   подставляем код, который человек ввёл.
   Отличить «такого кода нет» от «к этой корзине не подходит» по ответу
   корзины Shopify нельзя (оба приходят как applicable:false), поэтому
   формулировка общая и честная для обоих случаев. */
(function () {
  var lastCode = '';

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('cart-discount__form')) return;
    var i = f.querySelector('.cart-discount__input');
    lastCode = i ? i.value.trim().toUpperCase() : '';
  }, true);

  function rewrite(el) {
    if (!lastCode || el.classList.contains('hidden')) return;
    var text = 'Code ' + lastCode + ' can’t be applied to your cart';
    if (el.textContent.trim() !== text) el.textContent = text;
  }

  new MutationObserver(function () {
    document.querySelectorAll('[ref="cartDiscountErrorDiscountCode"]').forEach(rewrite);
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['class']
  });
})();
